export enum UserStatus
{
    /// <summary>
    /// The user is able to sign in.
    /// </summary>
    Active = 100,

    /// <summary>
    /// The user is not able to sign in.
    /// </summary>
    Disabled = 200,

    /// <summary>
    /// The user has been deleted.
    /// </summary>
    Deleted = 300,

    /// <summary>
    /// The user has been deleted for all intents and purposes of non-CTC users. User data is retained to avoid orphaned records.
    /// </summary>
    PermanentlyDeleted = 400,

    /// <summary>
    /// The users has requested to join an existing organization and their membership is pending approval
    /// </summary>
    Pending = 500,

    /// <summary>
    /// The user exists solely to be passed as an argument during automation API operations
    /// </summary>
    Automation = 600
}